"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MyAccountPage = void 0;
const doshx_controls_web_1 = require("doshx_controls_web");
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const console_1 = require("../../../reducers/slices/console");
const react_router_dom_1 = require("react-router-dom");
const user_1 = require("../../../reducers/slices/user/user");
const update_user_thunk_1 = require("../../../reducers/slices/user/thunks/update_user_thunk");
const document_1 = require("../../../reducers/slices/document/document");
const main_1 = require("../../../reducers/slices/main");
const add_signature_1 = require("./document/components/add_signature");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
const MyAccountPage = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const { user } = (0, react_redux_1.useSelector)((state) => state.userState);
    const onControlChanged = (name, value) => {
        dispatch((0, user_1.setUser)(Object.assign(Object.assign({}, user), { [name]: value })));
    };
    (0, react_1.useEffect)(() => {
        dispatch((0, console_1.setPageTitle)("My Account"));
        dispatch((0, console_1.setShowMenu)(true));
    }, []);
    return (react_1.default.createElement("div", { className: "px-2 sm:px-0" },
        react_1.default.createElement("div", { className: "flex flex-col gap-4 bg-white my-4 p-4 rounded-md" },
            react_1.default.createElement("div", { className: "w-full flex flex-col gap-y-4" },
                react_1.default.createElement("div", { className: "grid lg:flex gap-4 w-full" },
                    react_1.default.createElement("div", { className: "w-full" },
                        react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "First Name", type: "text", value: user.name, borderColor: "border-borders", onChange: (v) => {
                                onControlChanged("name", v);
                            } })),
                    react_1.default.createElement("div", { className: "w-full" },
                        react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "Last Name", type: "text", value: user.surname, borderColor: "border-borders", onChange: (v) => {
                                onControlChanged("surname", v);
                            } }))),
                react_1.default.createElement("div", { className: "grid lg:flex gap-4 w-full" },
                    react_1.default.createElement("div", { className: "w-full" },
                        react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "Email", type: "text", value: user.email, borderColor: "border-borders", onChange: (v) => {
                                onControlChanged("email", v);
                            } })),
                    react_1.default.createElement("div", { className: "w-full" },
                        react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "Phone Number", type: "text", borderColor: "border-borders", value: user.cell_number, onChange: (v) => {
                                onControlChanged("cell_number", v);
                            } }))),
                react_1.default.createElement("div", { className: "flex flex-col md:flex-row gap-8" },
                    react_1.default.createElement("div", { className: "flex flex-col items-center" },
                        react_1.default.createElement("span", { className: "font-semibold text-lg mb-2" }, "Signature"),
                        react_1.default.createElement("div", { className: "w-[200px] border border-dashed border-black text-center", onClick: () => {
                                var _a;
                                if (user.signature)
                                    dispatch((0, document_1.setSignature)(user.signature));
                                dispatch((0, main_1.setContentModal)({
                                    title: `${(user === null || user === void 0 ? void 0 : user.signature) ? "Update" : "Add"} Signature`,
                                    content: (react_1.default.createElement(add_signature_1.AddSignature, { value: (_a = user === null || user === void 0 ? void 0 : user.signature) !== null && _a !== void 0 ? _a : "", hide: true, onClick: (image) => {
                                            dispatch((0, update_user_thunk_1.update_user_thunk)({ data: { signature: image } }));
                                        } })),
                                }));
                            } }, (user === null || user === void 0 ? void 0 : user.signature) ? (react_1.default.createElement("img", { src: user === null || user === void 0 ? void 0 : user.signature })) : (react_1.default.createElement("div", { className: "m-auto" },
                            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faSignature, className: "font-bold text-black", size: "5x" }),
                            react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Signature here...", bold: true, textColor: "text-black" }))))),
                    react_1.default.createElement("div", { className: "flex flex-col items-center" },
                        react_1.default.createElement("span", { className: "font-semibold text-lg mb-2" }, "Initials"),
                        react_1.default.createElement("div", { className: "w-[200px] border border-dashed border-black text-center", onClick: () => {
                                var _a;
                                if (user.initials)
                                    dispatch((0, document_1.setSignature)(user.initials));
                                dispatch((0, main_1.setContentModal)({
                                    title: `${(user === null || user === void 0 ? void 0 : user.initials) ? "Update" : "Add"} Initials`,
                                    content: (react_1.default.createElement(add_signature_1.AddSignature, { value: (_a = user === null || user === void 0 ? void 0 : user.initials) !== null && _a !== void 0 ? _a : "", type: "Initials", hide: true, onClick: (image) => {
                                            dispatch((0, update_user_thunk_1.update_user_thunk)({ data: { initials: image } }));
                                        } })),
                                }));
                            } }, (user === null || user === void 0 ? void 0 : user.initials) ? (react_1.default.createElement("img", { src: user === null || user === void 0 ? void 0 : user.initials, alt: "User Initials" })) : (react_1.default.createElement("div", { className: "m-auto" },
                            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faSignature, className: "font-bold text-black", size: "5x" }),
                            react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Initials here...", bold: true, textColor: "text-black" })))))),
                react_1.default.createElement("div", { className: "flex justify-center" },
                    react_1.default.createElement("div", { className: "w-[200px]" },
                        react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Update", backgroundColor: "bg-secondary", onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                                const _user = Object.assign({}, user);
                                delete _user._id;
                                dispatch((0, update_user_thunk_1.update_user_thunk)({
                                    data: user,
                                }));
                            }) })))))));
};
exports.MyAccountPage = MyAccountPage;
